import React, { Component } from "react";
import { Grid, Row, Col, Button } from "react-bootstrap";
import Header from "./Header.jsx";
import Banner from "./Banner.jsx";
import BackButton from "./BackButton.jsx";
import MembersGrid from "./MembersGrid.jsx";
import hyperlinks from "../../../src/util/hyperlinks";

export default class CurrentMembers extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showOnMap: false
        };
        this.handleMapButtonClick = this.handleMapButtonClick.bind(this);
        this.updateState = this.updateState.bind(this);
    }

    handleMapButtonClick() {
        this.setState({ showOnMap: !this.state.showOnMap });
    }

    updateState(newState) {
        this.setState(newState);
    }

    render() {
        const mapButtonText = this.state.showOnMap ? "See members in a grid" : "See members on a map";
        return (
            <Header showCorporateMembers={this.props.showCorporateMembers} flashes={this.props.flashes} currentUser={this.props.currentUser}>
                <Grid className="with-background current-members-page">
                    <Banner heading="Current Members" />
                    <Row>
                        <Col md={3}>
                            <BackButton href={hyperlinks["membership"]} text="❮ Membership" />
                        </Col>
                        <Col md={3} mdOffset={6} className="text-right">
                            <Button className="see-members-on-a-map" onClick={this.handleMapButtonClick}>{mapButtonText}</Button>
                        </Col>
                    </Row>
                    <Row>
                        <MembersGrid
                            members={JSON.parse(this.props.currentMembers)}
                            showNames={true}
                            showOnMap={this.state.showOnMap}
                            innovationAreas={this.props.innovationAreas}
                            innovationAreasFor={this.props.innovationAreasFor}
                            activeFilters={this.props.activeFilters}
                            updateParentState={this.updateState}
                            currentUser={this.props.currentUser}
                            membersByCountry={this.props.membersByCountry}
                        />
                    </Row>
                </Grid>
            </Header>
        );
    }
}



// WEBPACK FOOTER //
// ./app/javascript/components/CurrentMembers.jsx.erb